import { AccessLevel, Areas } from 'app/models/permission.model';

/**
 * What a customer page needs, used as its route data (app.routing.ts): the level on an area,
 * checked by PermissionGuard, and a customer feature, checked by FeatureGuard. The navigation and
 * the start page read the same entries (StartPageService), so a menu item always opens its page.
 * Keyed by the route path; sub-routes (":id", "reports/summary") use their page's entry.
 */
export interface PageAccess {
  area?: string;
  access?: AccessLevel;
  feature?: string;
}

export const PAGE_ACCESS = {
  'dashboard': { area: Areas.Dashboard },
  'reports': { area: Areas.Reports },
  'reports/statistics': { area: Areas.ReportsStatistics },
  'reports/activity': { area: Areas.ReportsActivity },
  'device': { area: Areas.Devices },
  'staff': { area: Areas.Staff },
  'roles': { area: Areas.StaffAccessRights },
  'teams': { area: Areas.ReceiverTeams },
  'route': { area: Areas.AlarmRouting },
  'mobile-whitelist': { feature: 'EmaPhoneWhitelist', area: Areas.MobileWhitelist },
  'activity-log': { area: Areas.ActivityLog },
  'anna-perenna': { feature: 'AnnaPerenna', area: Areas.AnnaPerenna },
  'anna-perenna/edit': { feature: 'AnnaPerenna', area: Areas.AnnaPerenna, access: 'ReadWrite' },
  'onon': { feature: 'OnOn', area: Areas.OnOn },
  // OnOn profile and zone editing follows the AnnaPerenna (legacy) area: exactly the OnOn main user (40), MainUser and CustomerAdmin
  'onon/profiles': { feature: 'OnOn', area: Areas.AnnaPerenna, access: 'ReadWrite' },
  'camera-supervision': { feature: 'CameraSupervision', area: Areas.OnOn },
  'camera-supervision/new-visit': { feature: 'CameraSupervision', area: Areas.OnOn, access: 'ReadWrite' },
  'camera-configuration': { feature: 'CameraSupervision', area: Areas.Cameras, access: 'ReadWrite' },
  // Unloc lock rights (mock page, not in the navigation)
  'unloc': { area: Areas.DevicesLocks },
} satisfies Record<string, PageAccess>;
